import SubfactorHealthBadgeTooltip from './SubfactorHealthBadgeTooltip'

export default SubfactorHealthBadgeTooltip
